module.exports = __webpack_public_path__ + "static/media/background.1c1c9810.jpg";